export const getFileFromDataURI = (
  dataURI: string,
  filename: string,
  type: string,
) => {
  const byteString = atob(dataURI.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const blob = new Blob([ab], { type });
  const file = new File([blob], filename, { type });
  return file;
};

export const navigateToDetailPage = (
  route: string,
  detailIdx: string,
  value: string,
) => {
  const detailRoute = route.replace(detailIdx, value);
  return detailRoute;
};

export const downloadFile = (data: Blob | MediaSource, fileName: string) => {
  // create file link in browser's memory
  const href = URL.createObjectURL(data);

  // create "a" HTML element with href to file & click
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
